import { Injectable, inject } from '@angular/core';
import {
  AppService,
  DetectionService,
  MessageService,
  SimulationService,
  TaskService,
} from '@services';
import '@tensorflow/tfjs-backend-webgl';

const PENALTY_WORKER = 'penaltyWorker';

@Injectable({
  providedIn: 'root',
})
export class PenaltyService {
  private appService = inject(AppService);
  private detectionService = inject(DetectionService);
  private messageService = inject(MessageService);
  private simulationService = inject(SimulationService);
  private taskService = inject(TaskService);

  constructor() {
    this.detectionService.addWorkers({
      penaltyWorker: {
        id: 'penaltyWorker',
        model: 'default',
        historySize: 12,
        confidence: 0.2,
      },
    });
  }

  cycleCounter = 0;

  penaltyCounter = {
    rotation: 0,
  };

  penaltyState = {
    rotation: false,
  };

  async runPenaltyDetection() {
    /*     this.simulationService.nextCycle.subscribe(async () => {
      if (!(this.cycleCounter % 3)) {
        if (
          this.taskService.currentTaskId() === 'transfer' ||
          this.taskService.currentTaskId() === 'transferBack'
        ) {
          await this.detectionService.detect({
            modelName: 'default',
            workerId: PENALTY_WORKER,
            confidence: 0.2,
          });
          this.checkRotation().then((rotated) => {
            if (rotated !== null) {
              if (rotated && !this.penaltyState.rotation) {
                this.messageService.showMessage({
                  text:
                    'Bring the board back in position! (' +
                    (this.penaltyCounter.rotation + 1) +
                    'x)',
                  identifier: 'penalty' + this.penaltyCounter.rotation,
                  penalty: true,
                });

                this.penaltyState.rotation = true;
                this.penaltyCounter.rotation++;
              } else {
                this.penaltyState.rotation = false;
              }

              if (
                this.penaltyState.rotation &&
                !rotated &&
                this.messageService.currentMessage()
              ) {
                this.messageService.killCurrentMessage();
              }
            }
          });
        }
      }
      if (this.cycleCounter > 20000) {
        this.cycleCounter = 0;
      } else {
        this.cycleCounter++;
      }
    }); */
  }

  async checkRotation(): Promise<boolean | null> {
    const pegs = [
      ...this.detectionService.getAllBoxInstances('peg', PENALTY_WORKER),
      ...this.detectionService.getAllBoxInstances(
        'trianglePeg',
        PENALTY_WORKER,
      ),
    ].sort((a, b) => a.center.x - b.center.x);
    const THRESHOLD = 40;
    if (pegs.length >= 12) {
      const firstTwoPegs =
        this.appService.dominantHand() === 'right'
          ? pegs.slice(0, 2)
          : pegs.slice(-2);
      const xValues = firstTwoPegs.map((peg) => peg.center.x);
      const maxDiff = Math.max(...xValues) - Math.min(...xValues);
      const rotated = maxDiff > THRESHOLD;
      return rotated;
    } else {
      return null;
    }
  }
}
